import type { VoiceUiActionsPort } from './voice-ui-actions.port';

/**
 * Open the shared choose-structure / template picker (same signal as the V2
 * "Change template" row). Dismissible so Esc / outside click can cancel.
 *
 * Minimizes the voice workspace first: the overlay sits at z-90 and would
 * otherwise cover the choose-structure dialog (z-50).
 */
export const openChooseStructurePicker = (port: VoiceUiActionsPort): void => {
  port.minimizeVoiceWorkspace();
  port.setChooseNoteStructureModalDismissible(true);
  port.setChooseNoteStructureModalOpen(true);
};
